const t = {
  name: "Lock4",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5 13V15H13V18H11V15H8.5V13H15.5Z" fill="currentColor"/>
<path d="M12 1C9.23858 1 7 3.23858 7 6V8H6C4.89543 8 4 8.89543 4 10V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10C20 8.89543 19.1046 8 18 8H17V6C17 3.23858 14.7614 1 12 1ZM15 8H9V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V8ZM6 10H18V20H6V10Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Lock4
};
